export function authErrorMessageEs(err) {
  const code = err?.code || '';
  if (code === 'auth/popup-closed-by-user' || code === 'auth/cancelled-popup-request') {
    return 'Cerraste la ventana de Google antes de terminar. Probá de nuevo.';
  }
  if (code === 'auth/popup-blocked') {
    return 'El navegador bloqueó la ventana de Google. Habilitá pop-ups para este sitio y reintentá.';
  }
  if (code === 'auth/network-request-failed') {
    return 'No hay conexión estable. Revisá tu internet y reintentá.';
  }
  if (code === 'auth/user-disabled') {
    return 'Esta cuenta fue deshabilitada por moderación.';
  }
  if (code === 'auth/account-exists-with-different-credential') {
    return 'Ese correo ya tiene cuenta con otro método. Contactá al admin.';
  }
  if (code === 'auth/unauthorized-domain') {
    return 'Dominio no autorizado para iniciar sesión con Google.';
  }
  if (code === 'auth/internal-error') {
    return 'Error interno de Google. Probá de nuevo en unos segundos.';
  }
  return err?.message || 'No pudimos iniciarte sesión. Probá de nuevo.';
}
